import { useRouter } from 'next/router'

import isOracleAvailableOnPath from '~/aioracle/utils/isOracleAvailableOnPath.utils'

import HamburgerMenu from '~/menu/components/HamburgerMenu'

import StreakComponent from './StreakComponent'
import XpPill from './XpPill'
import { MenuRightPreview } from './MenuRightPreview'
import { NotificationBellButton } from './NotificationBellButton'
import { OracleButton } from './OracleButton'
import { SpaceButton } from './SpaceButton'

export const MenuRight = ({
  authenticated,
  hideOracleButton = false,
}: {
  authenticated: boolean
  hideOracleButton?: boolean
}): React.ReactElement => {
  const { asPath } = useRouter()

  return (
    <div className="flex items-center gap-2">
      {!authenticated && <MenuRightPreview />}
      {authenticated && (
        <>
          <StreakComponent />
          <XpPill />
          <NotificationBellButton />
        </>
      )}
      {!hideOracleButton && isOracleAvailableOnPath(asPath) && <OracleButton />}
      {authenticated && <SpaceButton />}
      <HamburgerMenu />
    </div>
  )
}
